import styled from 'styled-components';
import { ReactComponent as RefreshImage } from 'Images/reload.svg';

// eslint-disable-next-line import/prefer-default-export
export const RefreshIcon = styled(RefreshImage)`
`;
RefreshIcon.displayName = 'RefreshIcon';
